import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
export var OptionsMenuToggleWithText = function OptionsMenuToggleWithText(_a) {
  var _a$parentId = _a.parentId,
      parentId = _a$parentId === void 0 ? '' : _a$parentId,
      toggleText = _a.toggleText,
      _a$toggleTextClassNam = _a.toggleTextClassName,
      toggleTextClassName = _a$toggleTextClassNam === void 0 ? '' : _a$toggleTextClassNam,
      toggleButtonContents = _a.toggleButtonContents,
      _a$toggleButtonConten = _a.toggleButtonContentsClassName,
      toggleButtonContentsClassName = _a$toggleButtonConten === void 0 ? '' : _a$toggleButtonConten,
      _a$onToggle = _a.onToggle,
      onToggle = _a$onToggle === void 0 ? function () {
    return null;
  } : _a$onToggle,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      ariaHasPopup = _a['aria-haspopup'],
      parentRef = _a.parentRef,
      onEnter = _a.onEnter,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Options menu' : _a$ariaLabel,
      props = __rest(_a, ["parentId", "toggleText", "toggleTextClassName", "toggleButtonContents", "toggleButtonContentsClassName", "onToggle", "isOpen", "isPlain", "isDisabled", "isActive", 'aria-haspopup', "parentRef", "onEnter", 'aria-label']);

  return React.createElement("div", Object.assign({
    className: css(styles.optionsMenuToggle, styles.modifiers.text, isPlain && styles.modifiers.plain, isDisabled && styles.modifiers.disabled, isActive && styles.modifiers.active)
  }, props), React.createElement("span", {
    className: css(styles.optionsMenuToggleText, toggleTextClassName)
  }, toggleText), React.createElement("button", {
    className: css(styles.optionsMenuToggleButton, toggleButtonContentsClassName),
    id: "".concat(parentId, "-toggle"),
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-expanded": isOpen,
    onClick: function onClick() {
      return onToggle(!isOpen);
    }
  }, React.createElement("span", {
    className: css(styles.optionsMenuToggleButtonIcon)
  }, toggleButtonContents)));
};